module.exports = __webpack_public_path__ + "static/plusminus-b952ceda168dc046f10f895ca931b0f8.png";